import { useEffect, useState } from 'react';
import CustomBlockButton from '../../../components/button/CustomBlockButton';
import { CustomDialog } from '../../../components/dialog/v1/CustomDialog';
import * as St from './index.styled';
import { v4 as uuidv4 } from 'uuid';
import { useApiInfoContextValueHook } from '../../../contexts/ApiInfoContextProvider';
import { SellertoolSignatureUtils } from '../../../utils/sellertool-signature-utils';
import { CustomBackdropController } from '../../../components/backdrop/default/v1';
import axios from 'axios';
import { customToast } from '../../../components/toast/custom-react-toastify/v1';
import { CustomLabelInput } from '../../../components/input/CustomLabelInput';

const API_HOST = process.env.REACT_APP_MAIN_API_HOST;

export function MainView(props) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const [inboundStages, setInboundStages] = useState(null);
    const [addModalOpen, setAddModalOpen] = useState(false);

    useEffect(() => {
        handleReqFetch();
    }, []);

    const handleOpenAddModal = () => {
        setAddModalOpen(true);
    }

    const handleCloseAddModal = () => {
        setAddModalOpen(false);
    }

    const handleReqFetch = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        CustomBackdropController().showBackdrop();
        const insertResult = await axios.get(`${API_HOST}/inbound-stages`, {
            headers: headers,
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            })

        if (insertResult?.content) {
            setInboundStages(insertResult?.content);
        }
        CustomBackdropController().hideBackdrop();
    }

    const handleReqAdd = async (newStage) => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            inboundStage: newStage
        }

        CustomBackdropController().showBackdrop();
        const insertResult = await axios.post(`${API_HOST}/inbound-stages`, body, {
            headers: headers,
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            })

        if (insertResult?.content) {
            setInboundStages(insertResult?.content);
            handleCloseAddModal();
        }
        CustomBackdropController().hideBackdrop();
    }

    // 스테이지를 삭제하는 요청
    const handleReqRemoveStage = async (id) => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        });

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        };

        CustomBackdropController().showBackdrop();
        const deleteResult = await axios.delete(`${API_HOST}/inbound-stages/${id}`, {
            headers: headers,
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                };
            })
            .catch(err => {
                customToast.error(err.response);
            });

        if (deleteResult?.content) {
            setInboundStages(deleteResult?.content);
        }
        CustomBackdropController().hideBackdrop();
    };


    return (
        <>
            <St.EventButtons.Container>
                <CustomBlockButton
                    type='button'
                    onClick={() => handleOpenAddModal()}
                >추가</CustomBlockButton>
            </St.EventButtons.Container>
            <St.ListField.Container>
                <St.ListField.Wrapper>
                    {inboundStages?.map(inboundStage => {
                        return (
                            <St.ListField.Item key={inboundStage?.uuid}>
                                <div className='flex gap-2 justify-between items-center'>
                                    <div className='flex-1'>
                                        <div className='uuid'>({inboundStage?.name}) {inboundStage?.uuid}</div>
                                        <div className='status'>
                                            <div className={`${inboundStage?.status === 'PREPARING' ? 'active' : ''}`}>준비중</div>
                                            <div>&gt;</div>
                                            <div className={`${inboundStage?.status === 'REGISTERED' ? 'active' : ''}`}>입고 등록됨</div>
                                            <div>&gt;</div>
                                            <div className={`${inboundStage?.status === 'WORKING' ? 'active' : ''}`}>파레트 작업중</div>
                                            <div>&gt;</div>
                                            <div className={`${inboundStage?.status === 'COMMITED' ? 'active' : ''}`}>완료됨</div>
                                        </div>
                                    </div>
                                    <CustomBlockButton
                                        type='button'
                                        onClick={() => handleReqRemoveStage(inboundStage?._id)}
                                    >삭제</CustomBlockButton>
                                </div>
                            </St.ListField.Item>
                        );
                    })}
                </St.ListField.Wrapper>
            </St.ListField.Container>
            {addModalOpen &&
                <AddModal
                    open={addModalOpen}
                    onClose={handleCloseAddModal}
                    onReqAdd={handleReqAdd}
                />
            }
        </>
    );
}

function AddModal({
    open,
    onClose,
    onReqAdd
}) {
    const [newStage, setNewStage] = useState({
        _id: null,
        uuid: uuidv4(),
        name: '',
        status: 'PREPARING' // [PREPARING, REGISTERED, WORKING, COMMITED]
    })

    const handleSubmit = async () => {
        if (!newStage?.name) {
            customToast.error('스테이지 이름을 입력해주세요.');
            return;
        }
        onReqAdd(newStage)
    }
    return (
        <CustomDialog open={open} onClose={() => onClose()}>
            <St.AddModal.BodyContainer>
                <div>
                    <CustomLabelInput>
                        <CustomLabelInput.Input
                            type='text'
                            value={newStage?.name || ''}
                            onChange={(e) => setNewStage({ ...newStage, name: e.target.value })}
                        />
                        <CustomLabelInput.Label>스테이지 이름<span style={{ color: 'var(--redColor1)' }}> *</span></CustomLabelInput.Label>
                    </CustomLabelInput>
                </div>
                <div className='notice'>
                    새로운 스테이지({newStage?.uuid})를 생성합니다.
                </div>
                <div className='footerButtons'>
                    <CustomBlockButton
                        type='button'
                        onClick={() => onClose()}
                    >취소</CustomBlockButton>
                    <CustomBlockButton
                        type='button'
                        className='confirm'
                        onClick={() => handleSubmit()}
                    >생성</CustomBlockButton>
                </div>
            </St.AddModal.BodyContainer>
        </CustomDialog>
    );
}